import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { convertLegacyEntityCardExtension } from '@backstage/plugin-catalog-react/alpha';
import {
  EntityAwsCodeBuildCard,
  isAwsCodeBuildAvailable,
} from '@aws/aws-codebuild-plugin-for-backstage';

/**
 * AWS CodeBuild entity card. Same legacy bridge as aws-ecs — see that
 * module's header comment and docs/operations.md → "AWS Labs plugin suite".
 */
const awsCodeBuildEntityCard = convertLegacyEntityCardExtension(
  EntityAwsCodeBuildCard,
  {
    name: 'aws-codebuild',
    filter: isAwsCodeBuildAvailable,
  },
);

export const awsCodeBuildModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [awsCodeBuildEntityCard],
});
